import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class EmployeeService extends BaseService {
	constructor() {
		super('/Employee');
	}


	public getAllByFilter(filter: EmployeeFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class EmployeeFilter extends BaseFilter {
	constructor(idTenant?: number | null, isDeleted: boolean | null = false) {
		super();
		this._idTenant = idTenant;
		this._isDeleted = isDeleted;
	}

	private _idTenant?: number | null;
	private _isDeleted?: boolean | null;

	public getAllParams(): {} {
	
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._isDeleted != null ? { IsDeleted: this._isDeleted } : {})
		);
	
		return data;
	};
}